import { makeStyles } from "@material-ui/styles";

const scoreBoardStyles = makeStyles(() => ({
	teamSummary: {
		flex: 1
	},
	overall: {
		padding: 20
	},
	eventText: {
		fontFamily: "Barlow Condensed",
		fontSize: 16,
		fontWeight: 600,
		letterSpacing: 0
	},
	eventSummary: {
		color: "#5B5B5B"
	}
}));

export default scoreBoardStyles;
